var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "app-container view-container",
      attrs: {
        "label-position": "top",
        model: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            " " + _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Basic")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.tryCancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      [
        _c(
          "el-row",
          { attrs: { gutter: 10 } },
          [
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessAfterCsgReturn.table.cusName"),
                      prop: "cusName",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: { "option-list": _vm.CUSTOMER_LIST },
                      on: { change: _vm.cusChange },
                      model: {
                        value: _vm.form.cusId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cusId", $$v)
                        },
                        expression: "form.cusId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseOrderDetail.table.associatedCode"
                      ),
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.thirdCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "thirdCode", $$v)
                        },
                        expression: "form.thirdCode",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessAfterCsgReturn.table.reference"),
                      prop: "remark",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        type: "textarea",
                        "show-word-limit": "",
                        autosize: "",
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remark", $$v)
                        },
                        expression: "form.remark",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      _c(
        "div",
        { staticClass: "bj-row mt20" },
        [
          _c(
            "BjDivider",
            [
              _vm._v(
                _vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Product")) + " "
              ),
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleShowFnForDialogSkuList },
                  },
                  [_vm._v(_vm._s(_vm.$t("BusinessAfterCsgReturn.table.add")))]
                ),
              ],
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "bj-col bj-col-24",
              staticStyle: { "border-left": "none" },
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.form.goodsList,
                    border: "",
                    script: "",
                    "max-height": "600px",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "standardSkuCode",
                      label: "SKU",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "barCode",
                      label: _vm.$t("BusinessPurchaseDetailPage.table.Barcode"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " + _vm._s(_vm.$t("goodsSku.detail.qty")) + " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjInputNumber", {
                              staticClass: "full-width",
                              attrs: { min: 1, clearable: "", controls: false },
                              model: {
                                value: row.planQty,
                                callback: function ($$v) {
                                  _vm.$set(row, "planQty", $$v)
                                },
                                expression: "row.planQty",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "BusinessAfterCsgReturn.table.checkCounts"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjInputNumber", {
                              staticClass: "full-width",
                              attrs: { min: 1, clearable: "", controls: false },
                              model: {
                                value: row.checkCounts,
                                callback: function ($$v) {
                                  _vm.$set(row, "checkCounts", $$v)
                                },
                                expression: "row.checkCounts",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "BusinessAfterCsgReturn.table.skuStatus"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.RETURN_PRODUCT_STATUS,
                              },
                              model: {
                                value: row.skuStatus,
                                callback: function ($$v) {
                                  _vm.$set(row, "skuStatus", $$v)
                                },
                                expression: "row.skuStatus",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("table.operationText"),
                      fixed: "right",
                      align: "center",
                      width: "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete(row, $index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delText")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("AddingAnInternalReturnRefundDoc.Picture"))),
      ]),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { display: "block", height: "100%" },
              attrs: { label: "" },
            },
            [
              _c(
                "BjUpload",
                {
                  ref: "BjUpload",
                  staticClass: "avatar-uploader",
                  attrs: {
                    limit: 20,
                    "limit-size": 5 * 1024,
                    multiple: "",
                    "show-file-list": "",
                    "list-type": "picture-card",
                    accept: "image/png,image/jpeg",
                    "accept-list": ["image/jpeg", "image/png"],
                    "auto-upload": "",
                    "limit-hide": "",
                  },
                  on: { afterUpload: _vm.afterUpload, remove: _vm.onRemoveUrl },
                },
                [
                  _c("template", { slot: "default" }, [
                    _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon",
                    }),
                  ]),
                  _c("template", { slot: "tip" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessAfterCsgReturn.uploadHindText1")
                        ) + ":"
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("BusinessAfterCsgReturn.uploadHindText2")
                        ) +
                        " "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          config: _vm.$BjDialogListConfig.skuDefault("SelectSKUText", {
            defaultQuery: _vm.defaultQuery,
            columns: _vm.columns,
            search: _vm.search,
            actionApi: _vm.actionApi,
          }),
        },
        on: { confirm: _vm.onAddDialogConfirm },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }